var app = angular.module('leonardo');

var BaseService = function($http, $q) {
  return function() {
    var service = {
      collection: []
    };
    service.getURL = function (options) {
      // This is intentional do_something blank function
    };
    service.get = function (options) {
      var promise = $q.defer();
      $http.get(service.getURL(options)).then(function (item) {
        service.processItem(options, item).then(function (newItem) {
          promise.resolve(newItem);
        }, function (error) {
          promise.reject(error);
        });
      }).catch(function(error){
        promise.reject(error);
      });
      return promise.promise;
    };

    service.post = function(url, data) {
      var defer = $q.defer();
      $http.post(service.getURL(url), data).then(function(item) {
        service.processItem(url, item).then(function(newItem) {
          defer.resolve(newItem);
        }, function (error) {
          defer.reject(error);
        });
      }).catch(function (error) {
        defer.reject(error);
      });
      return defer.promise;
    };

    service.patch = function(pk, data) {
      var options = { pk: pk };
      var defer = $q.defer();
      $http.patch(service.getURL(options), data).then(function(item) {
        service.processItem(options, item).then(function(newItem) {
          defer.resolve(newItem);
        }, function (error) {
          defer.reject(error);
        });
      }).catch(function (error) {
        defer.reject(error);
      });
      return defer.promise;
    };

    service.delete = function(pk) {
      var options = { pk: pk };
      var defer = $q.defer();
      $http.delete(service.getURL(options)).then(function(data) {
        defer.resolve(data);
      }).catch(function (error) {
        defer.reject(error);
      });
      return defer.promise;
    };

    service.processItem = function (options, item) {
      var promise = $q.defer();
      promise.resolve(item);
      return promise.promise;
    };
    service.list = function (options, overrideURL) {
      options = options ? options : {};
      var url = overrideURL ? overrideURL : service.getURL(options);
      var uri = new URI(url);
      var filters = {};
      if ('filters' in options) {
        angular.forEach(options.filters, function (value, key) {
          if (value !== '') {
            filters[key] = value;
          }
        });
      }
      if (options.page) {
        filters['page'] = options.page;
      }
      uri.query(filters);

      var promise = $q.defer();
      $http.get(uri.toString()).then(function (data) {
        var all = [];
        angular.forEach(data.results, function (result) {
          all.push(service.processItem(options, result));
        });
        $q.all(all).then(function () {
          service.collection = data;
          promise.resolve(data);
        }, function(error) {
          promise.reject(error);
        });
      }).catch(function (error) {
        promise.reject(error);
      });
      return promise.promise;
    };

    service.all = function (options) {
      options = options ? options : {};
      var defer = $q.defer();
      var all = [];
      var recursive = function (page) {
        var opt = angular.copy(options);
        opt['page'] = page;
        service.list(opt).then(function (data) {
          all = _.union(all, data.results);
          if (all.length == data.count) {
            service.collection = all;
            defer.resolve({
              results: all,
              count: all.length
            });
            return;
          }
          recursive(page + 1);
        }, function() {
          defer.resolve(all);
        });
      };
      recursive(1);

      return defer.promise;
    };
    return service;
  };
};

app.factory('BaseService', ['$http', '$q', BaseService]);
